export const DOCTOR_INFO_UPDATED_EVENT = "doctorInfoUpdated";

/** Profil güncellendiğinde Topbar / Sidebar gibi bileşenleri bilgilendirir. */
export function emitDoctorInfoUpdated(doctorInfo) {
  window.dispatchEvent(
    new CustomEvent(DOCTOR_INFO_UPDATED_EVENT, { detail: doctorInfo })
  );
}

/** localStorage user kaydını güncel doktor bilgisiyle senkronize eder. */
export function syncStoredUserFromDoctorInfo(doctorInfo) {
  const doctor = doctorInfo?.doctor || doctorInfo;
  if (!doctor?.id) return;

  const userStr = localStorage.getItem("user");
  if (!userStr) return;

  try {
    const user = JSON.parse(userStr);
    if (doctor.name != null) user.name = doctor.name;
    if (doctor.surname != null) user.surname = doctor.surname;
    if (doctor.specialization != null) user.specialization = doctor.specialization;
    if (doctor.nationality != null) user.nationality = doctor.nationality;
    localStorage.setItem("user", JSON.stringify(user));
  } catch (e) {
    console.error("Error syncing user from doctor info:", e);
  }
}
